export default {
    methods: {
        currencyFormat(currency) {
            return currency === 'Ft'
                ? {
                    symbol: 'Ft',
                    thousandsSeparator: ' ',
                    fractionCount: 0,
                    fractionSeparator: '.',
                    symbolPosition: 'back',
                    symbolSpacing: true,
                    avoidEmptyDecimals: '',
                }
                : {
                    symbol: '€',
                    thousandsSeparator: ',',
                    fractionCount: 2,
                    fractionSeparator: '.',
                    symbolPosition: 'back',
                    symbolSpacing: true,
                    avoidEmptyDecimals: '',
                }
        },

        currencyFormatWithValue(currency, value) {
            return currency === 'Ft'
                ? {
                    value: value,
                    symbol: 'Ft',
                    thousandsSeparator: ' ',
                    fractionCount: 0,
                    fractionSeparator: '.',
                    symbolPosition: 'back',
                    symbolSpacing: true,
                    avoidEmptyDecimals: '',
                }
                : {
                    value: value,
                    symbol: '€',
                    thousandsSeparator: ',',
                    fractionCount: 2,
                    fractionSeparator: '.',
                    symbolPosition: 'back',
                    symbolSpacing: true,
                    avoidEmptyDecimals: '',
                }
        }
    }
}
